import React, { useState, useEffect } from 'react';
import {
  Button,
  Box,
  Tooltip,
  TextField,
  Container,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Modal,
  Typography,
  Checkbox,
  FormControlLabel,
  useTheme,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const EditManageModuleQuiz = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [viewResult, setViewResult] = useState(false);
  
const [openSnackbar, setOpenSnackbar] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState('');
const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [setTime, setSetTime] = useState(false);
  const [reAttempt, setReAttempt] = useState(false);
  const [date, setDate] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [courseName, setCourseName] = useState('');
  const [moduleName, setModuleName] = useState('');
  const [quizName, setQuizName] = useState('');
  const [maxAttempts, setMaxAttempts] = useState('');
  const [duration, setDuration] = useState('');
  const [noOfQuestions, setNoOfQuestions] = useState('');
  const [totalSingleChoose, setTotalSingleChoose] = useState('');
  const [totalMultipleChoose, setTotalMultipleChoose] = useState('');
  const [totalTrueFalse, setTotalTrueFalse] = useState('');
  const [marksPerQuestion, setMarksPerQuestion] = useState('');
  const [passMarks, setPassMarks] = useState('');
  const [negativeMarking, setNegativeMarking] = useState('0');

  const staticCourseData = [
    { id: 1, name: 'Mathematics' },
    { id: 2, name: 'Science' },
    { id: 3, name: 'History' },
    { id: 4, name: 'Geography' },
    { id: 5, name: 'Literature' },
  ];

  const staticModuleData = [
    { id: 1, name: 'Introduction' },
    { id: 2, name: 'Advanced' },
    { id: 3, name: 'Practical' },
    { id: 4, name: 'Theory' },
    { id: 5, name: 'Applications' },
  ];

  const staticQuizData = [
    { quizId: 1, quizName: 'Quick Quiz', duration: '30', numberOfQuestions: 20 },
  ];

  useEffect(() => {
    if (staticQuizData.length > 0) {
      const quiz = staticQuizData[0];
      setQuizName(quiz.quizName);
      setDuration(quiz.duration);
      setNoOfQuestions(quiz.numberOfQuestions);
    }
  }, []);

  const handleSave = (e) => {
    e.preventDefault();
    if (!courseName || !moduleName || !quizName || !maxAttempts || !duration || !noOfQuestions || !marksPerQuestion || !passMarks) {
      setSnackbarMessage('plz fill rquired field!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("error");
      return;
    }
   
 setShowSuccessModal(true)
  };

  const handleCancel = () => {
    navigate(-1)
  };

  return (
    <Container maxWidth="lg" sx={{ my: 0 }}>
      <Box
        sx={{
          p: 4,
          borderRadius: 2,
          backgroundColor: theme.palette.background.paper,
        }}
      >
           <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 3,
                  }}
                >
                  <Typography variant="h5" sx={{ fontWeight: 'bold', color: theme.palette.primary.main }}>
                    Quiz Details
                  </Typography>
                  
                </Box>
        <form onSubmit={handleSave}>
          <Box sx={{ display: 'flex', gap: 3, mb: 3 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={viewResult}
                  onChange={(e) => setViewResult(e.target.checked)}
                  
          sx={{
                        color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary,
                        '&.Mui-checked': { color: theme.palette.primary.main },
                      }}
                />
              }
              label="View Result"
              sx={{ '& .MuiTypography-root': { color: theme.palette.text.primary } }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={setTime}
                  onChange={(e) => setSetTime(e.target.checked)}
                  
       sx={{
                        color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary,
                        '&.Mui-checked': { color: theme.palette.primary.main },
                      }}
                />
              }
              label="Set Time"
              sx={{ '& .MuiTypography-root': { color: theme.palette.text.primary } }}
            />
          </Box>

          {setTime && (
            <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
              <TextField
                label="Date"
                type="date"
                variant="outlined"
                fullWidth
                value={date}
                onChange={(e) => setDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{
                  '& .MuiInputLabel-root': {
                    color: theme.palette.text.primary,
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: theme.palette.primary.main,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              />
              <TextField
                label="Start Time"
                type="time"
                variant="outlined"
                fullWidth
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{
                  '& .MuiInputLabel-root': {
                    color: theme.palette.text.primary,
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: theme.palette.primary.main,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              />
              <TextField
                label="End Time"
                type="time"
                variant="outlined"
                fullWidth
                value={endTime}
                onChange={(e) => setEndTime(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{
                  '& .MuiInputLabel-root': {
                    color: theme.palette.text.primary,
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: theme.palette.primary.main,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              />
            </Box>
          )}

          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
            <FormControl fullWidth required sx={{ '& .MuiInputLabel-root': { color: theme.palette.text.primary }, '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main } }}>
              <InputLabel>Course Name</InputLabel>
              <Select
                value={courseName}
                label="Course Name"
                onChange={(e) => setCourseName(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {staticCourseData.map((course) => (
                  <MenuItem key={course.id} value={course.name}>
                    {course.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
            <FormControl fullWidth required sx={{ '& .MuiInputLabel-root': { color: theme.palette.text.primary }, '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main } }}>
              <InputLabel>Module Name</InputLabel>
              <Select
                value={moduleName}
                label="Module Name"
                onChange={(e) => setModuleName(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {staticModuleData.map((module) => (
                  <MenuItem key={module.id} value={module.name}>
                    {module.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
            <TextField
              label="Quiz Name"
              variant="outlined"
              fullWidth
              value={quizName}
              onChange={(e) => setQuizName(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
              }}
              required
            />
          </Box>

          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
            <TextField
              label="Maximum Attempts"
              variant="outlined"
              type="number"
              fullWidth
              value={maxAttempts}
              onChange={(e) => setMaxAttempts(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
              }}
              required
            />
            <TextField
              label="Duration (minutes)"
              variant="outlined"
              type="number"
              fullWidth
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
              }}
              required
            />
          </Box>

          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
            <TextField
              label="Number of Questions"
              variant="outlined"
              type="number"
              fullWidth
              value={noOfQuestions}
              onChange={(e) => setNoOfQuestions(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
              }}
              required
            />
          </Box>

          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
            <TextField
              label="Total Single Choose Questions"
              variant="outlined"
              type="number"
              fullWidth
              value={totalSingleChoose}
              onChange={(e) => setTotalSingleChoose(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
              }}
            />
            <TextField
              label="Total Multiple Choose Questions"
              variant="outlined"
              type="number"
              fullWidth
              value={totalMultipleChoose}
              onChange={(e) => setTotalMultipleChoose(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
              }}
            />
          </Box>

          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
            <TextField
              label="Total True and False Questions"
              variant="outlined"
              type="number"
              fullWidth
              value={totalTrueFalse}
              onChange={(e) => setTotalTrueFalse(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
              }}
            />
          </Box>

          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
            <TextField
              label="Marks Per Question"
              variant="outlined"
              type="number"
              fullWidth
              value={marksPerQuestion}
              onChange={(e) => setMarksPerQuestion(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
              }}
              required
            />
            <TextField
              label="Pass Marks"
              variant="outlined"
              type="number"
              fullWidth
              value={passMarks}
              onChange={(e) => setPassMarks(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
              }}
              required
            />
          </Box>

          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
            <FormControl fullWidth sx={{ '& .MuiInputLabel-root': { color: theme.palette.text.primary }, '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main } }}>
              <InputLabel>Negative Marking</InputLabel>
              <Select
                value={negativeMarking}
                onChange={(e) => setNegativeMarking(e.target.value)}
                label="Negative Marking"
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                <MenuItem value="0">0</MenuItem>
                <MenuItem value="-1">-1</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <FormControlLabel
            control={
              <Checkbox
                checked={reAttempt}
                onChange={(e) => setReAttempt(e.target.checked)}
                 sx={{
                        color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary,
                        '&.Mui-checked': { color: theme.palette.primary.main },
                      }}
              />
            }
            label="Re-attempt"
            sx={{ '& .MuiTypography-root': { color: theme.palette.text.primary } }}
          />

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 }}>
            <Tooltip
              title={
                !courseName ? "Select Course" :
                !moduleName ? "Select Module" :
                !quizName ? "Enter Quiz Name" :
                !maxAttempts ? "Enter Maximum Attempts" :
                !duration ? "Enter Duration" :
                !noOfQuestions ? "Enter Number of Questions" :
                !marksPerQuestion ? "Enter Marks Per Question" :
                !passMarks ? "Enter Pass Marks" : ""
              }
              arrow
            >
              <span>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={!courseName || !moduleName || !quizName || !maxAttempts || !duration || !noOfQuestions || !marksPerQuestion || !passMarks}
                  sx={{
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': { backgroundColor: theme.palette.primary.dark },
                  }}
                >
                  UPDATE
                </Button>
              </span>
            </Tooltip>
            <Button
              variant="outlined"
              color="error"
              onClick={handleCancel}
            >
              CANCEL
            </Button>
           
          </Box>
        </form>

        <Modal
          open={showSuccessModal}
          onClose={() => setShowSuccessModal(false)}
          BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 400,
              bgcolor: theme.palette.background.paper,
              borderRadius: 2,
              boxShadow: 24,
              overflow: 'hidden',
            }}
          >
            <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px' }}>
              <Typography variant="h6" sx={{ color: theme.palette.primary.contrastText }}>
                Quiz Updated ✅
              </Typography>
            </Box>
            <Box sx={{ padding: '20px' }}>
              <Typography sx={{ mb: 2 }}>
                Quiz details have been updated successfully.
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setShowSuccessModal(false);
                    navigate(-1);
                  }}
                >
                  OK
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>
      </Box>
      
<Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
};

export default EditManageModuleQuiz;
